import useTableStateParams from "@/components/Table/hooks/useTableState";

import BorderContainer from "@/components/ContentContainer/BorderContainer";
import PrimarySourceTag from "@/components/StatusTags/PrimarySourceTag/PrimarySourceTag";
import ProxyTag from "@/components/StatusTags/ProxyTag/ProxyTag";
import Table from "@/components/Table/Table";
import { Tag } from "antd";
import { ConsumableRelation, useGetConsumable, useGetConsumableRelations } from "../useConsumables";
import styles from "@/pages/consumables/ConsumableDetail/ConsumableDetail.module.scss";
import Skeleton from "@/components/Skeleton/Skeleton";
import ConsumableRelationsPerYear from "@/pages/consumables/ConsumableDetail/ConsumableRelationsPerYear";

export default function ConsumableRelations({ consumableId }: { consumableId: number }) {
  const { pagination, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 10 },
  });
  const { data, isLoading, isFetching } = useGetConsumableRelations({ consumableId, pagination });
  const { data: consumable, isLoading: consumableIsLoading } = useGetConsumable({ consumableId });

  if (data?.total_count === 0)
    return (
      <BorderContainer>
        This consumable is not referenced in any product or facility.
      </BorderContainer>
    );

  return (
    <>
      <div className={styles.relationContainer}>
        <div className={styles.item}>
          <h3>Products</h3>
          <span className={styles.metric}>
            <Skeleton
              loading={consumableIsLoading}
              style={{ width: 20, height: 24 }}
            >
              {consumable?.product_relations}
            </Skeleton>
          </span>
        </div>
        <div className={styles.item}>
          <h3>Facilities</h3>
          <span className={styles.metric}>
            <Skeleton
              loading={consumableIsLoading}
              style={{ width: 20, height: 24 }}
            >
              {consumable?.facility_relations}
            </Skeleton>
          </span>
        </div>
      </div>
      <ConsumableRelationsPerYear consumableId={consumableId} />
      <Table<ConsumableRelation>
        loading={isLoading || isFetching}
        type="grey"
        emptyState={{ hide: true }}
        hideRaster={true}
        pagination={pagination}
        totalRows={data?.total_count}
        data={data?.data}
        onSearchFilterSortPaginate={onSearchFilterSortPaginate}
        rowLink={(record) =>
          ["product_proxy", "product_source", "product"].includes(record.type)
            ? `/products/${record.id}/usage`
            : `/facilities/${record.id}`
        }
        columns={[
          {
            label: "Name",
            key: "name",
            renderer: (record) => record.name,
          },
          {
            label: "Relation",
            key: "relation",
            renderer: (record) => (
              <>
                {record.type === "product_source" ? (
                  <>
                    <Tag>Product</Tag>
                    <PrimarySourceTag />
                  </>
                ) : record.type === "product_proxy" ? (
                  <>
                    <Tag>Product</Tag>
                    <ProxyTag />
                  </>
                ) : record.type === "product" ? (
                  <>
                    <Tag>Product</Tag>
                  </>
                ) : record.type === "facility" ? (
                  <Tag>Facility</Tag>
                ) : (
                  ""
                )}
              </>
            ),
          },
        ]}
        rowKey={"row_id"}
      />
    </>
  );
}
